// ReportingPowerBI.jsx
import EmbeddedReport from "./EmbeddedReport";
import { mapReportItemToPbi } from "./pbiAdapter";

export default function ReportingPowerBI({ clientId, tenantId, report }) {
  const mapped = mapReportItemToPbi(report);
  if (!mapped) {
    return <div className="p-4 text-red-600">Missing Power BI IDs (reportId/groupId/ctid).</div>;
  }
  return (
    <EmbeddedReport
      clientId={clientId}
      tenantId = {tenantId}
      reportItemId = {report._id}
      reportId={mapped.reportId}
      groupId={mapped.groupId}
      ctid={mapped.ctid}
      height={860}
    />
  );
}
